import { RootState } from 'redux/reducers/rootReducer';
import { createSelector } from '@reduxjs/toolkit';
import { PayCodeModel } from 'api/adminApiClient';

import { EnhancedPayCodeDetail } from 'components/modals/AssignmentDataModal/FinancialInfo/interfaces';

const assignmentCreatedAtSelector = (state: RootState) =>
  state.assignment.assignmentCreatedAt;
const assignmentDraftCreatedAtSelector = (state: RootState) =>
  state.assignment.assignmentDraftCreatedAt;
const jobTitlesSelector = (state: RootState) => state.assignment.jobTitles;
const isJobTitlesLoadingSelector = (state: RootState) =>
  state.assignment.isJobTitlesLoading;
const workCodesSelector = (state: RootState) => state.assignment.workCodes;
const isWorkCodesLoadingSelector = (state: RootState) =>
  state.assignment.isWorkCodesLoading;
const payCodesDetailsInfoSelector = (state: RootState) =>
  state.assignment.payCodes;
const typesPayCodeSelector = (state: RootState) =>
  state.assignment.typesPayCode;
const payCodesGroupsSelector = (state: RootState) =>
  state.assignment.payCodesGroups;
const isPayCodesGroupsLoadingSelector = (state: RootState) =>
  state.assignment.isPayCodesGroupsLoading;
const isTypesPayCodeLoadingSelector = (state: RootState) =>
  state.assignment.isTypesPayCodeLoading;
const payRateTypesSelector = (state: RootState) =>
  state.assignment.payRateTypes;
const isPayCodeTypesLoadingSelector = (state: RootState) =>
  state.assignment.isPayCodeTypesLoading;
const assignmentDetailsSelector = (state: RootState) =>
  state.assignment.assignmentDetails;
const isTemplateAssignmentModalOpenSelector = (state: RootState) =>
  state.assignment.isTemplateAssignmentModalOpen;
const assignmentTemplateCreatedAtSelector = (state: RootState) =>
  state.assignment.assignmentTemplateCreatedAt;
const assignmentDetailsUpdatedAtByAdminSelector = (state: RootState) =>
  state.assignment.assignmentDetailsUpdatedAtByAdmin;

const payCodesSelector = createSelector(
  payCodesDetailsInfoSelector,
  typesPayCodeSelector,
  (payCodesDetailsInfo, typesPayCode) => {
    return typesPayCode?.map((typePayCode) => {
      const payCodesDetails = typePayCode?.payCodeId
        ?.map((codeId) => {
          const found = payCodesDetailsInfo.find((o) => o.id === codeId);
          return found ? found : null;
        })
        .filter((item) => item !== null) as PayCodeModel[] | undefined;
      return {
        assignmentType: typePayCode.assignmentType,
        payCodeDetails: payCodesDetails,
      };
    });
  },
);

const enhancedPayCodesSelector = createSelector(
  payRateTypesSelector,
  payCodesDetailsInfoSelector,
  (payRateTypes, payCodesDetails): EnhancedPayCodeDetail[] => {
    const payRateTypeMap = new Map(
      payRateTypes.map((type) => [type.id, type.name]),
    );

    return payCodesDetails.map((payCodeDetail) => ({
      ...payCodeDetail,
      payRateTypeName: payRateTypeMap.get(payCodeDetail.payRateTypeId) || null,
    }));
  },
);

export {
  jobTitlesSelector,
  assignmentDetailsSelector,
  assignmentCreatedAtSelector,
  assignmentDraftCreatedAtSelector,
  isJobTitlesLoadingSelector,
  isTemplateAssignmentModalOpenSelector,
  assignmentTemplateCreatedAtSelector,
  assignmentDetailsUpdatedAtByAdminSelector,
  payRateTypesSelector,
  isPayCodeTypesLoadingSelector,
  payCodesDetailsInfoSelector,
  workCodesSelector,
  isWorkCodesLoadingSelector,
  typesPayCodeSelector,
  isTypesPayCodeLoadingSelector,
  payCodesSelector,
  enhancedPayCodesSelector,
  payCodesGroupsSelector,
  isPayCodesGroupsLoadingSelector,
};
